/* one% buy dialog (marketplace mode). "Buy now" calls OnePercentBuy.open(variantId): the dialog shows
   the chosen product, flavour, pack and price, with one button per store linking straight to that
   SKU's listing (variant metafield), or to the store-level link from Theme settings when a SKU has none.
   Every open and store click is published as a Shopify customer event (Settings > Customer events)
   and pushed to dataLayer / gtag / fbq when those exist. Markup: snippets/op-buy-dialog.liquid. */
(() => {
  if (window.OnePercentBuy) return;

  const data = () => window.ONEPERCENT_BUY || { stores: [], variants: {} };
  const WORDMARK = { shopee: true, tokopedia: true, blibli: true };

  function track(name, detail) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, detail);
      }
    } catch (e) { /* analytics must never block the link */ }
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail));
    try { if (typeof window.gtag === 'function') window.gtag('event', name, detail); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, detail); } catch (e) {}
  }

  // UTM tags so a store's own traffic report (where it has one) can tell website clicks apart.
  function tag(url, key) {
    try {
      const u = new URL(url);
      u.searchParams.set('utm_source', 'onepercentnutrition.id');
      u.searchParams.set('utm_medium', 'website');
      u.searchParams.set('utm_campaign', 'buy_dialog');
      if (key) u.searchParams.set('utm_content', key);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function el(tag, cls, text) {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  const dialog = () => document.querySelector('[data-op-buy]');

  function render(d, item) {
    const q = (s) => d.querySelector(s);
    q('[data-op-buy-product]').textContent = item.product || '';
    q('[data-op-buy-title]').textContent = item.flavour || item.product || '';
    q('[data-op-buy-meta]').textContent = [item.pack, item.price].filter(Boolean).join(' · ');
    const img = q('[data-op-buy-img]');
    if (item.image) { img.src = item.image; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }

    const base = {
      variant_id: item.id ? String(item.id) : '',
      sku_key: item.key || '',
      product: item.product || '',
      flavour: item.flavour || '',
      pack: item.pack || '',
      price: item.price || '',
      page: location.pathname,
    };
    const links = item.links || {};
    const buttons = data().stores.map((s) => {
      const own = links[s.id];
      const url = own || s.fallback;
      if (!url) return null;
      const a = el('a', 'op-buy__store');
      a.href = tag(url, item.key);
      a.target = '_blank';
      a.rel = 'noopener';
      a.dataset.store = s.id;
      const logo = el('img', 'op-buy__logo');
      logo.src = s.logo;
      logo.alt = '';
      logo.loading = 'lazy';
      const name = el('span', 'op-buy__name' + (WORDMARK[s.id] ? ' op-buy__name--hidden' : ''), s.name);
      const go = el('span', 'op-buy__go', '→');
      go.setAttribute('aria-hidden', 'true');
      a.append(logo, name, go);
      a.addEventListener('click', () => track('marketplace_click', Object.assign({ store: s.id, link: own ? 'listing' : 'store' }, base)));
      return a;
    }).filter(Boolean);
    q('[data-op-buy-stores]').replaceChildren(...buttons);
    track('buy_dialog_open', base);
  }

  function open(variantId, fallback) {
    bind();
    const d = dialog();
    if (!d) return false;
    const known = variantId != null ? data().variants[String(variantId)] : null;
    const item = Object.assign({}, fallback || {}, known || {}, { id: variantId });
    if (fallback && fallback.image) item.image = fallback.image; // the shop panel's flavour cutout beats the product photo
    render(d, item);
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
    const first = d.querySelector('.op-buy__store');
    if (first) first.focus({ preventScroll: true });
    return true;
  }

  function close() {
    const d = dialog();
    if (!d) return;
    if (typeof d.close === 'function') d.close();
    else d.removeAttribute('open');
  }

  function bind() {
    const d = dialog();
    if (!d || d.dataset.bound) return;
    d.dataset.bound = '1';
    d.addEventListener('click', (e) => {
      // A click on the dimmed backdrop lands on the <dialog> itself, outside the sheet.
      if (e.target === d || e.target.closest('[data-op-buy-close]')) close();
    });
  }

  window.OnePercentBuy = { open, close, track };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
